import { getRequest, type IValidatedResponse } from '../../httpClient';
import {
  getMovieRatingInsightsV1ResponseSchema,
  type IGetMovieRatingInsightsV1Response,
} from './get-movie-rating-insights-v1-response';

export async function getMovieRatingInsightsV1Api(): Promise<
  IValidatedResponse<IGetMovieRatingInsightsV1Response>
> {
  return getRequest<IGetMovieRatingInsightsV1Response>({
    path: '/sys/movies/v1/rating-insights',
    schema: getMovieRatingInsightsV1ResponseSchema,
  });
}
